export default "__VITE_ASSET__BvNI$g6J__"